<template>
  <b-modal class="modal-lg" id="newParentLink" title='New Parent Link' :header-bg-variant="'secondary'" hide-backdrop okVariant="secondary" ok-only @hide="hideModal()">
    <template slot="modal-header" slot-scope="{ close }">
      <h5 class="modal-title text-light">
        New Parent Link <span class="os-icon os-icon-info text-light" id="popover-target-1"></span>
        <b-popover custom-class="wide-popover" target="popover-target-1" triggers="hover" placement="top">
          <template #title>Parent Link</template>
          <span class="mb-2">This modal is used to create a new parent entry in the navbar ( the highest level navigation ). After creating a new parent navigation the user can add sub-navigation links to it.</span>
          <li>Link URL corresponds to what can be seen in the browser url, example "documents/search" when viewing document search page ( for parent navigation this name can be same as link name, spaces need to be replaced with "_" )</li>
          <li>Link Translation Key is the translation key that can be used after creating a new link</li>
          <li>Link Position determines where the new parent link should be placed ( the higher the number the more to the right the link will appear )</li>
        </b-popover>
      </h5>
      <button aria-label="Close" class="close" data-dismiss="modal" type="button" @click="close()"><span aria-hidden="true" class="text-light">X</span></button>
    </template>
    <template slot="default">
      <div class="row">
        <div class="col-12">
          <b-form-group id="input-group-1" label="Link URL" label-for="input-1">
            <b-form-input id="input-1" v-model="newLink.url" type="text" required placeholder="Link Url"></b-form-input>
          </b-form-group>
          <b-form-group id="input-group-2" label="Link Translation Key" label-for="input-2">
            <b-form-input id="input-2" v-model="newLink.translationKey" type="text" required placeholder="Translation Key"></b-form-input>
          </b-form-group>
          <b-form-group id="input-group-3" label="Link Position" label-for="input-3">
            <b-form-input id="input-3" v-model="newLink.position" type="text" required placeholder="Position"></b-form-input>
          </b-form-group>
          <b-form-group id="input-group-4" label="Navigation Icon" label-for="input-4">
            <b-form-input id="input-4" v-model="newLink.navbarIcon" type="text" required placeholder="Navigation Icon"></b-form-input>
            <b-popover target="input-4" triggers="focus" title="Tip">
              <template slot="default">
                <div class="text-size-small">
                  <p>List of icons can be found <span class="text-primary clickable-link" @click="openIconsList()">here</span></p>
                </div>
              </template>
            </b-popover>
          </b-form-group>
          <b-form-group id="input-group-5" label="Navigation Background Icon" label-for="input-5">
            <b-form-input id="input-5" v-model="newLink.navbarBackgroundIcon" type="text" required placeholder="Navigation Background Icon"></b-form-input>
            <b-popover target="input-5" triggers="focus" title="Tip">
              <template slot="default">
                <div class="text-size-small">
                  <p>List of icons can be found <span class="text-primary clickable-link" @click="openIconsList()">here</span></p>
                </div>
              </template>
            </b-popover>
          </b-form-group>
          <b-form-group id="input-group-6" label="Allowed User Levels" label-for="input-6" v-if="$props.userLevels">
            <div v-for="level in userLevels" :key="level.name" class="pl-1">
              <b-form-checkbox :id="'checkbox-' + level.name" v-model="newLink.userLevels[level.id]" :name="'checkbox-' + level.name" value="1" unchecked-value="0">{{ level.name }}</b-form-checkbox>
            </div>
          </b-form-group>
        </div>
      </div>
    </template>
    <template slot="modal-footer" slot-scope="{ cancel }">
      <button aria-label="Cancel" data-dismiss="modal" class="btn btn-secondary" type="button" @click="cancel()">
        <fontAwesomeIcon :icon="['fa', 'ban']" class="text-light mr-2"/>Cancel
      </button>
      <button aria-label="Create Link" data-dismiss="modal" class="btn btn-primary" type="button" :disabled="isBusy" @click="createParentLink()">
        <fontAwesomeIcon :icon="['fa', 'thumbs-up']" class="text-light mr-2"/>Create Link
      </button>
    </template>
  </b-modal>
</template>

<script>
export default {
  name: 'NewParentNavigationModal',
  props: ['userLevels'],
  data() {
    return {
      newLink: {
        url: '',
        translationKey: '',
        position: 0,
        group: 0,
        parent: 0,
        navbarIcon: '',
        navbarBackgroundIcon: '',
        userLevels: {},
        type: ''
      },
      isBusy: false
    }
  },
  methods: {
    hideModal() {
      this.$parent.disableOverlay()
    },
    createParentLink() {
      this.newLink.type = 'new_parent_link_created'
      let self = this
      this.$store.dispatch('menuBuilderStore/createNewLink', this.newLink).then(() => {
        self.$parent.disableOverlay()
        self.$parent.getNavigation()
        self.$root.$emit('bv::hide::modal', 'newParentLink')
      })
    },
    openIconsList() {
      window.open('http://light.pinsupreme.com/icon_fonts_light_admin.html','_blank')
    },
    clearData() {
      this.newLink.url = ''
      this.newLink.translationKey = ''
      this.newLink.position = 0
      this.newLink.navbarIcon = ''
      this.newLink.navbarBackgroundIcon = ''
      this.newLink.userLevels = {}
    }
  }
}
</script>

<style>
.clickable-link {
  cursor: pointer;
  color: #047bf8;
}

.clickable-link:hover {
  font-weight: 600;
  text-decoration: underline;
}

.wide-popover {
  min-width: 500px !important;
  padding: 10px;
}
</style>